var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeJuice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9EFE2;}\n\t.st1{fill:#CF6919;}\n\t.st2{fill:#F29024;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#548630;}\n\t.st5{fill:#FAC37B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.27,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C28.98,148.54,63.58,182.83,106.27,182.83"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.62,
    y: 47.42,
    className: "st1",
    width: 19.37,
    height: 7.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8,
    y: 71.9,
    className: "st1",
    width: 40.29,
    height: 87.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115.99,54.54 96.6,54.45 95.8,71.9 136.09,71.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.46,
    y: 71.9,
    className: "st2",
    width: 40.29,
    height: 87.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "96.6,54.45 76.46,71.9 116.74,71.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.87,147.83H88.72c-4.34,0-7.85-3.52-7.85-7.85V91.56c0-4.34,3.52-7.85,7.85-7.85h16.15 c4.34,0,7.85,3.52,7.85,7.85v48.41C112.72,144.31,109.21,147.83,104.87,147.83z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.36,104.23c-7.09,1.45-10.9,7.47-9.63,13.68c1.27,6.21,7.04,9.81,14.13,8.36c7.09-1.45,11-7.02,9.73-13.23 C107.32,106.83,101.45,102.78,94.36,104.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.2,103.43c-7.25,1.48-11.67,7.78-10.27,14.64c1.37,6.72,7.72,10.5,15.09,8.99 c7.37-1.51,11.73-7.47,10.36-14.19C107.98,106.01,101.45,101.95,94.2,103.43z M98.7,125.48c-6.56,1.34-11.97-1.84-13.18-7.73 c-1.24-6.06,2.55-11.41,9-12.73c6.45-1.32,12.03,2.12,13.27,8.18C108.99,119.09,105.25,124.14,98.7,125.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.41,106.54l-2.49-0.6c-0.25-0.06-0.5,0.09-0.56,0.34c-0.06,0.25,0.09,0.5,0.34,0.56l2.49,0.6 c0.07,0.02,0.14,0.02,0.2,0c0.17-0.03,0.32-0.17,0.36-0.35C96.81,106.85,96.66,106.6,96.41,106.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.81,105.55l-2.06,1.52c-0.21,0.15-0.25,0.44-0.1,0.65c0.11,0.15,0.29,0.21,0.47,0.18 c0.06-0.01,0.13-0.04,0.18-0.08l2.06-1.52c0.21-0.15,0.25-0.44,0.1-0.65C96.31,105.44,96.02,105.4,95.81,105.55z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M89.07,116.81c-0.44-0.31-1.04-0.2-1.35,0.24c-0.31,0.44-0.2,1.04,0.24,1.35c0.44,0.31,1.04,0.2,1.35-0.24 C89.61,117.72,89.5,117.12,89.07,116.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M89.21,120.22c-0.21,0.3-0.14,0.71,0.16,0.92c0.3,0.21,0.71,0.14,0.92-0.16c0.21-0.3,0.14-0.71-0.16-0.92 C89.83,119.85,89.42,119.92,89.21,120.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M91.92,121.92c-0.17,0.24-0.11,0.57,0.13,0.73c0.24,0.17,0.57,0.11,0.73-0.13c0.17-0.24,0.11-0.57-0.13-0.73 C92.41,121.63,92.08,121.68,91.92,121.92z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeJuice);
export default __webpack_public_path__ + "static/media/Orange_juice.ef60f1d83ea0bd219ce2fec2a9278adc.svg";
export { ForwardRef as ReactComponent };